(() => {
  function mount(root) {
    if (root.cp46Mounted) return;
    root.cp46Mounted = true;
    let busy = false;
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-cp-load-more]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (busy) return;
      const grid = root.querySelector('[data-cp-product-grid]');
      const footer = root.querySelector('[data-cp-load-footer]');
      const error = footer.querySelector('[data-cp-load-error]');
      busy = true;
      link.textContent = 'Loading…';
      link.setAttribute('aria-disabled', 'true');
      grid.setAttribute('aria-busy', 'true');
      error.hidden = true;
      try {
        const url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Invalid destination');
        const response = await fetch(url.href, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = doc.querySelector('[data-cp-load-collection]');
        const nextGrid = nextRoot?.querySelector('[data-cp-product-grid]');
        const nextFooter = nextRoot?.querySelector('[data-cp-load-footer]');
        const cards = Array.from(nextGrid?.children || []);
        if (!cards.length || !nextFooter) throw new Error('Missing products');
        const first = cards[0].matches('a') ? cards[0] : cards[0].querySelector('a');
        const shouldFocus = document.activeElement === link;
        grid.append(...cards);
        footer.querySelector('[data-cp-load-count]').textContent = nextFooter.querySelector('[data-cp-load-count]').textContent;
        footer.querySelector('progress').value = nextFooter.querySelector('progress').value;
        const nextLink = nextFooter.querySelector('[data-cp-load-more]');
        if (nextLink) link.href = nextLink.href;
        else link.remove();
        if (shouldFocus) first?.focus({preventScroll:true});
      } catch (e) {
        error.hidden = false;
      } finally {
        busy = false;
        link.textContent = 'Load more';
        link.removeAttribute('aria-disabled');
        grid.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-cp-load-collection]').forEach(mount);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-cp-load-collection]').forEach(mount));
})();
